import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-906f87b2")

_pushScopeId("data-v-906f87b2")
const _hoisted_1 = { class: "full-container display-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_build_tree = _resolveComponent("build-tree")
  const _component_build_content_model = _resolveComponent("build-content-model")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_build_tree, { onChangeBuild: _ctx.changeBuild }, null, 8, ["onChangeBuild"]),
    _createVNode(_component_build_content_model, {
      class: "margin-left20px build-content",
      build: _ctx.build,
      deviceType: _ctx.deviceType
    }, null, 8, ["build", "deviceType"])
  ]))
})